import styled from 'styled-components';
import { Colors } from 'assets/colors';
import { WL_CONFIG } from 'constants';

export const StyledWrapper = styled.div`
  .segments-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }

  .segments-title {
    font-weight: 800;
    font-size: 28px;
    line-height: 34px;
    color: ${Colors.textPrimary1};
    margin: 0;
  }

  .segments-subtitle {
    font-size: 14px;
    color: #717679;
    margin-top: 4px;
  }

  .summary-cards {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 24px;
    @media (max-width: 991px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 575px) {
      grid-template-columns: 1fr;
    }
  }

  .summary-card {
    padding: 16px 20px;
    background: white;
    border: 1px solid #e8eaee;
    border-radius: 8px;
  }

  .summary-card-label {
    font-size: 12px;
    color: #717679;
    margin-bottom: 4px;
  }

  .summary-card-value {
    font-size: 24px;
    font-weight: 700;
    color: ${Colors.textPrimary1};
  }

  .search-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: ${WL_CONFIG.colors.primary};
    border-radius: 8px;
    margin-bottom: 16px;
  }

  .search-bar .ant-input-affix-wrapper,
  .search-bar .ant-input-affix-wrapper:hover,
  .search-bar .ant-input-affix-wrapper:focus,
  .search-bar .ant-input-affix-wrapper-focused {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }

  .search-bar .ant-input {
    flex: 1;
    border: none;
    background: transparent !important;
    color: white !important;
    font-size: 14px;
    &::placeholder {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .search-bar .ant-input-clear-icon {
    color: rgba(255, 255, 255, 0.8) !important;
    &:hover {
      color: white !important;
    }
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 24px;
    text-align: center;
  }

  .empty-illustration {
    width: 200px;
    height: 160px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${WL_CONFIG.colors.primary};
    opacity: 0.6;
  }

  .empty-title {
    font-weight: 700;
    font-size: 18px;
    color: ${Colors.textPrimary1};
    margin-bottom: 8px;
  }

  .empty-desc {
    font-size: 14px;
    color: #717679;
    margin-bottom: 24px;
    max-width: 400px;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
`;
